module.exports = __webpack_public_path__ + "img/ico_delivery_address_bk.56bbc00.svg";